export default [
	{
		modulo: 26,
		privilegio: 193,
		routerName: 'contratos-abastecimento',
		routerPath: '/contratos-abastecimento',
		componentName: 'CadastroContratosAbastecimento',
		componentPath: 'modules/layout/gestao-contratos/abastecimento/main'
	},
	{
		modulo: 18,
		privilegio: 150,
		routerName: 'contratos-sbh',
		routerPath: '/contratos-sbh',
		componentName: 'CadastroContratoSBH',
		componentPath: 'modules/layout/gestao-contratos/sbh/main'
	}
]
